export const INPUT_VARIANT = { _: "_", INTAKE_FORM: "intake-form" };
